import {
  AnalyticsConfiguration_GTM,
  AnalyticsConfiguration_GTM_Graphql_Request_Fragment,
} from "./gtm/model";
import {
  AnalyticsConfiguration_XO,
  AnalyticsConfiguration_XO_Graphql_Request_Fragment,
} from "./xo/model";

export interface AnalyticsConfiguration {
  sessionId?: string;
  ecommerceId?: string;

  xo?: AnalyticsConfiguration_XO;
  gtm?: AnalyticsConfiguration_GTM;
}

export const AnalyticsConfiguration_Graphql_Request = `
  sessionId
  ecommerceId

  xo {
    ${AnalyticsConfiguration_XO_Graphql_Request_Fragment}
  }
  gtm {
    ${AnalyticsConfiguration_GTM_Graphql_Request_Fragment}
  }
`;
